import * as styles from "./IntroCircleImageAndSearch.module.scss";

import React from "react";
import SearchInput from "../../../components/SearchInput/SearchInput";
import CurvedBorderShallow from "../../../components/borders/CurvedBorderShallow";
import ProcessedImage from "../../../components/common/ProcessedImage/ProcessedImage";
import { Colours } from "../../../utils/colours";
export interface IntroCircleImageAndSearchProps {
	title: string;
	preHeading?: string;
	subHeading?: string;
	body: string;
	imgSrc: string;
	imgAlt: string;
	withSearch?: boolean;
	isMaintenance?: boolean;
}

export const IntroCircleImageAndSearch: React.FC<
	IntroCircleImageAndSearchProps
> = ({
	title,
	subHeading,
	body,
	imgSrc,
	imgAlt,
	withSearch = true,
	isMaintenance = false,
}) => {
	return (
		<div className={styles.introcirclewithsearchcontainer}>
			<div className={styles.contentarea}>
				<div className={styles.first}>
					<div className={styles.titlewrapper}>
						<div className={styles.title}>
							<h1>{title}</h1>
						</div>
						<div className={styles.subtitle}>{subHeading}</div>
					</div>
					<div
						className={styles.text}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
						dangerouslySetInnerHTML={{ __html: body }}
					/>
					{withSearch && (
						<div className={styles.search}>
							<SearchInput
								title=""
								name=""
								baseSearchUrl="/search"
								placeholder="Search the site"
								value=""
								justInput={true}
							/>
						</div>
					)}
				</div>
				<div className={styles.second}>
					<div className={styles.imagewrapper}>
						{isMaintenance ? (
							<img
								className={styles.maintenanceimage}
								src={imgSrc}
								alt={imgAlt}
								width={200}
								height={200}
							/>
						) : (
							<ProcessedImage
								src={imgSrc}
								alt={imgAlt}
								dimensions="400x300"
								height={300}
								width={400}
							/>
						)}
					</div>
				</div>
				<div className={styles.bordersection}>
					<CurvedBorderShallow
						className={styles.border}
						fill={Colours.SANDY_FUR}
						rotation={0}
					/>
				</div>
			</div>
		</div>
	);
};

export default IntroCircleImageAndSearch;
